export default function About() {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="card">
          <h1 className="text-4xl font-bold text-gray-900 mb-8 text-center">
            About CloudShare
          </h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-xl text-gray-600 mb-6">
              CloudShare is a modern, secure file sharing service built on Cloudflare's 
              global infrastructure. Share files up to 2GB with anyone, anywhere in the world.
            </p>
            
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Features</h2>
            <ul className="space-y-2 mb-6">
              <li>🚀 <strong>No Registration Required:</strong> Start sharing files immediately</li>
              <li>📁 <strong>Large File Support:</strong> Upload files up to 2GB</li>
              <li>🔒 <strong>Password Protection:</strong> Secure your files with optional passwords</li>
              <li>⏰ <strong>Auto Expiry:</strong> Files automatically expire for privacy</li>
              <li>🌍 <strong>Global CDN:</strong> Fast downloads worldwide via Cloudflare</li>
              <li>📊 <strong>Download Tracking:</strong> Monitor download counts and limits</li>
            </ul>
            
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Technology Stack</h2>
            <p className="mb-4">
              CloudShare is built with modern technologies for security, speed, and reliability:
            </p>
            <ul className="space-y-2 mb-6">
              <li><strong>Frontend:</strong> React + TypeScript + Tailwind CSS</li>
              <li><strong>Backend:</strong> Cloudflare Workers</li>
              <li><strong>Storage:</strong> Cloudflare R2 (S3-compatible)</li>
              <li><strong>Database:</strong> Cloudflare KV for metadata</li>
              <li><strong>Hosting:</strong> Cloudflare Pages</li>
            </ul>
            
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Privacy & Security</h2>
            <p className="mb-4">
              Your privacy is our priority. Here's how we protect your files:
            </p>
            <ul className="space-y-2 mb-6">
              <li>Files are stored securely in Cloudflare R2</li>
              <li>Optional password protection with bcrypt encryption</li>
              <li>Automatic file expiry (configurable from 1 hour to 30 days)</li>
              <li>Download limits to prevent unauthorized sharing</li>
              <li>No tracking or analytics on your files</li>
            </ul>
            
            <div className="bg-blue-50 p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-blue-900 mb-2">Open Source</h3>
              <p className="text-blue-800">
                CloudShare is open source and built as a demonstration of modern 
                file sharing using Cloudflare's edge computing platform.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
} 